import request from '@/utils/request';
import { datasetEndpoint } from '@/constants/urls';

const links = (code) => request({
  url: `${datasetEndpoint(code)}/actions`,
  params: { valid: false },
  method: 'GET',
});

const DatasetLinkService = {
  links,
};

export default DatasetLinkService;
